module.exports = __webpack_public_path__ + "img/selected1-min.90ff242d.png";